module.exports = __webpack_public_path__ + "img/process1.7f25a334.png";